import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { useCustomerStore } from '@stores/me/customer'

import { useBookingsApiDemo } from './demo.hook'
import { useBookingsApiPaid } from './paid.hook'

interface BookingsApiPayload {
  disciplineId: number
  background: boolean
  skipStore?: boolean
  from?: string
  to?: string
}
interface BookingsApiOptions {
  onStart?: () => void
  onSuccess?: (bookings: Booking[]) => void
}

export const useBookingsApi = async (payload: BookingsApiPayload, options?: BookingsApiOptions) => {
  const customerStore = useCustomerStore()

  if (customerStore.isDisciplinePaidById(payload.disciplineId)) {
    await useBookingsApiPaid(payload, options)
  } else {
    await useBookingsApiDemo(payload, options)
  }
}
